// extracted by mini-css-extract-plugin
module.exports = {"container":"OurServicesSection_container__d_M7u","title":"OurServicesSection_title__kUHoN","button":"OurServicesSection_button___Ell1","box":"OurServicesSection_box__3BwMD"};